export class CreateGroupModal{
    constructor(
        private groupName:string,
        private icdList:any[],
        private cptList:any[],
        private preOpList:any[],
        private procList:any[],
        private medList:any[],
        private vendorList:any[]



    ){
        
    }
}